import {
  detectTouch,
  orientation,
  windowHeightVar
} from './utilities/helpers.js';
// import fontface from './modules/fontface/index.js' // to include fontface event listner to ensure smooth design on load.
import includes from '../../includes/**/*.js';
// import modules from '../../modules/blocks/**/*.js';
import barba from './modules/barba/index.js';
import blockviews from '../../views/blocks/**/*.js';

function init() {
  
  orientation();
  windowHeightVar();
  detectTouch();
  barba();
 
// what do these do (in relation to the twgi complilatin)
// and why two seperate folders - i.e what should be the usage reason(s) for each
//   Object.keys(includes).forEach((item) => {

//     console.log("includes",includes);
//     const include = includes[item]
//     console.log("include:",includes[item]);

//     if (
//       include &&
//       Object.prototype.hasOwnProperty.call(include[item], 'default')
//     ) {
//       include[item].default()
//     }
//  })


  // console.log("modules",modules);

  // Object.keys(modules).forEach((item) => {

  //   const module = modules[item]
  //   // console.log("module", module);

  //   if (
  //     module &&
  //     Object.prototype.hasOwnProperty.call(module[item], 'default')

  //   ) {
  //     module[item].default()
  //   }

  // })


  // console.log("blockviews",blockviews);

  Object.keys(blockviews).forEach((item) => {

    const module = blockviews[item]
    //  console.log("blockviews module", module);
    if (
      module &&
      Object.prototype.hasOwnProperty.call(module[item], 'default')

    ) {
      module[item].default()
    }

  })

}

export default init